<template>
  <div>
      <main-header></main-header>
      <div class="registermain">
          <div class="w1200 registerbg">
              <div class="registerformbox">
                  <div class="title">{{language[languagetype].title}}</div>
                  <div :class="lang == 1 ? 'inputbox' : 'inputboxen'">
                    <span>{{language[languagetype].name}}</span>
                    <input type="text" :placeholder="language[languagetype].namereg" v-model="name">
                  </div>
                  <div :class="lang == 1 ? 'inputbox' : 'inputboxen'">
                    <span>{{language[languagetype].company}}</span>
                    <input type="text" :placeholder="language[languagetype].companyplea" v-model="company">
                  </div>
                  <div :class="lang == 1 ? 'inputbox' : 'inputboxen'">
                    <span>{{language[languagetype].iphone}}</span>
                    <input type="text" :placeholder="language[languagetype].iphoneplea" v-model="mobile">
                  </div>
                  <div :class="lang == 1 ? 'inputbox' : 'inputboxen'">
                    <span>{{language[languagetype].email}}</span>
                    <input type="text" :placeholder="language[languagetype].emailplea" v-model="email">
                  </div>
                  <div :class="lang == 1 ? 'inputbox2' : 'inputboxen2'">
                    <span>{{language[languagetype].code}}</span>
                    <input type="text" :placeholder="language[languagetype].codeplea" v-model="code">
                    <div class="codetext">{{codetext}}</div>
                  </div>
                  <div class="submitbtn" @click="submit">
                      {{language[languagetype].submit}}
                  </div>
              </div>
          </div>
      </div>
      <toast ref="toasttext"></toast>
  </div>
</template>

<script>
import MainHeader from './header'
import Fetch from '../js/ajaxa'
import toast from '../components/taast/toast'
let languagetext = require('../js/registerlang.json')

export default {
  name: 'index',
  data () {
    return {
      codepic: '',
      name: '',
      company: '',
      mobile: '',
      email: '',
      code: '',
      codetext: '',
      language: {},
      languagetype: 'cn'
    }
  },
  methods: {
    submit: function () {
      var regEmail = /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/
      var regiphone = /^1[3-9]\d{9}$/
      const that = this
      if (that.name === '') {
        that.$refs.toasttext.show(that.language[that.languagetype].usernull)
        return false
      }
      if (that.company === '') {
        that.$refs.toasttext.show(that.language[that.languagetype].companynull)
        return false
      }
      if (that.mobile === '') {
        that.$refs.toasttext.show(that.language[that.languagetype].iphonenull)
        return false
      }
      if (!regiphone.test(that.mobile)) {
        that.$refs.toasttext.show(that.language[that.languagetype].iphonereg)
        return false
      }
      if (that.email !== '' && !regEmail.test(that.email)) {
        that.$refs.toasttext.show(that.language[that.languagetype].emailreg)
        return false
      }
      if (that.code == null || that.code === '') {
        that.$refs.toasttext.show(that.language[that.languagetype].codenull)
        that.coderefresh()
        return false
      }
      if (that.code !== that.codetext) {
        that.$refs.toasttext.show(that.language[that.languagetype].codeerr)
        that.coderefresh()
        return false
      }
      Fetch.post('Api/reg', {
        name: that.name,
        company: that.company,
        captcha: that.captcha,
        mobile: that.mobile,
        email: that.email
      }).then((res) => {
        that.$router.push({name: 'succful'})
      }).catch(err => {
        console.log(err)
        that.$refs.toasttext.show(that.language[that.languagetype].submitfail)
        that.coderefresh()
      })
    },
    coderefresh: function () {
      const that = this
      that.codetext = ''
      var codeChars = [ 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z' ]
      for (var i = 0; i < 4; i++) {
        that.codetext = codeChars[Math.floor(Math.random() * 36)] + this.codetext
      }
    }
  },
  created () {
    this.coderefresh()
    const that = this
    that.language = languagetext
    that.lang = sessionStorage.getItem('lang') || 1
    // eslint-disable-next-line
    if (that.lang != 1) {
      that.languagetype = 'en'
    }
  },
  components: {
    MainHeader, toast
  },
  beforeCreate () {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.registermain{min-height: 683px;background-color: #F6F6F6;overflow: hidden;}
.registerbg{height: 580px;margin-top: 50px;background-color: #Fff;}
.registerformbox{width: 310px;height: 100%;overflow: hidden;margin: 0 auto;}
.registerformbox .title{width: 100%;height: 85px;line-height: 85px;margin-top: 16px;text-align: center;font-size: 30px;color: #333333;}
.inputbox{width: 100%;height: 40px;border-bottom: 1px solid #c5c5c5;overflow: hidden;display: flex;margin-bottom: 28px;}
.inputbox span{width: 70px;flex-shrink: 0;line-height: 40px;font-size: 16px;}
.inputbox input{border: none;outline: none;text-align: right;flex: 1;min-width: 80px;}
.inputboxen{width: 100%;height: 67px;border-bottom: 1px solid #c5c5c5;overflow: hidden;display: flex;flex-wrap: wrap;}
.inputboxen span{width: 100%;flex-shrink: 0;line-height: 25px;font-size: 16px;margin-top: 10px;}
.inputboxen input{border: none;outline: none;text-align: left;flex: 1;min-width: 80px;height: 25px;width: 100%;}
.inputbox2{width: 100%;height: 40px;border-bottom: 1px solid #c5c5c5;overflow: hidden;display: flex;margin-bottom: 28px;}
.inputbox2 input{border: none;outline: none;flex: 1;text-align: right;margin-right: 5px;}
.inputbox2 span{width: 70px;flex-shrink: 0;line-height: 40px;font-size: 16px;}
.inputbox2 .codetext{width: 30%;height: 40px;background-color: #D8B7E3;display: flex;align-items: center;justify-content: center;font-size: 16px;}
.inputboxen2{width: 100%;height: 67px;border-bottom: 1px solid #c5c5c5;overflow: hidden;display: flex;flex-wrap: wrap;margin-bottom: 28px;}
.inputboxen2 input{border: none;outline: none;flex: 1;text-align: left;margin-right: 5px;}
.inputboxen2 span{width: 100%;flex-shrink: 0;line-height: 25px;font-size: 16px;margin-top: 10px;font-size: 16px;}
.inputboxen2 .codetext{width: 30%;height: 40px;background-color: #D8B7E3;display: flex;align-items: center;justify-content: center;font-size: 16px;}

.inputbox .pic{width: 110px;height: 45px;margin-left: 46px;}
.submitbtn{width: 100%;height: 50px;background-color: #1C5CEF;text-align: center;line-height: 50px;font-size: 20px;color: #fff;cursor: pointer;}
</style>



// WEBPACK FOOTER //
// src/page/register.vue